import React from 'react';


const Results = (props) => (
    <table>
        <tbody>
            <tr>
                <th> Food </th>
                <th> A </th>
                <th> B </th>
                <th> AB </th>
                <th> O </th>
            </tr>
            { Object.keys(props.results).map((key, i) => {
                return (
                    <tr key={"result-" + i}>
                        <th> { key } </th>
                        <td className={ props.results[key].A.toLowerCase() }> { props.results[key].A } </td>
                        <td className={ props.results[key].B.toLowerCase() }> { props.results[key].B } </td>
                        <td className={ props.results[key].AB.toLowerCase() }> { props.results[key].AB } </td>
                        <td className={ props.results[key].O.toLowerCase() }> { props.results[key].O } </td>
                    </tr>
                )
            })}
        </tbody>
    </table>
)

export default Results


// WEBPACK FOOTER //
// ./src/components/results.js